<template>
	<!-- TODO нужно будет вернуть к такому виду  -->
	<!-- '--template-columns: 0.56fr 288px 0.44fr 150px 50px 120px' -->
	<div
		class="hd"
		:style="
			isAuth
				? '--template-columns: auto 50px 100px 100px 100px'
				: '--template-columns: 1fr 120px'
		"
	>
		<div class="hd__elm">
			<!-- /////////////////// -->
			<!-- LOGO -->
			<div class="hd__elm-logo" @click="onGoToHomepage">
				<IconLogo v-if="vue_app_theme === THEMES" />
				<IconLogoTapi v-else />
			</div>

			<!-- TODO временно закомментировано -->
			<!-- /////////////////// -->
			<!-- SEARCH -->
			<!--			<div v-if="isAuth" class="hd__elm-search">-->
			<!--				<input-->
			<!--					type="text"-->
			<!--					class="hd__elm-search-input"-->
			<!--					placeholder="Найти инстанс"-->
			<!--				/>-->

			<!--				<IconInputSearch class="hd__elm-search-icon" />-->
			<!--			</div>-->

			<!-- TODO временно закомментировано -->
			<!-- /////////////////// -->
			<!-- NOTIFY -->
			<!--			<div v-if="isAuth" class="hd__elm-notify">-->
			<!--				<div>-->
			<!--					<div @click="onClickNotify">-->
			<!--						<IconNotify class="hd__elm-notify-icon" />-->
			<!--						<div-->
			<!--							v-if="isNotify"-->
			<!--							class="hd__elm-notify-indicate"-->
			<!--						></div>-->
			<!--					</div>-->
			<!--					<ModalHeaderNotify-->
			<!--						v-if="modalNotify.isShow"-->
			<!--						class="hd__elm-notify-modal"-->
			<!--					/>-->
			<!--				</div>-->
			<!--			</div>-->

			<!-- TODO временно закомментировано -->
			<!-- /////////////////// -->
			<!-- BALANCE -->

			<!-- /////////////////// -->
			<!-- API -->
			<div v-if="isAuth">
				<div
					class="hd__elm-profile-label hd__elm-profile-label_api"
					@click="openApiUrlHandler"
				>
					API
				</div>
			</div>

			<div
				v-if="
					isAuth &&
					!isAdmin &&
					undefined !== tariffType &&
					1 !== tariffType
				"
				class="hd__elm-balance"
			>
				<IconBalance />
				<div class="hd__elm-balance-label">{{ balance }}</div>
			</div>

			<!-- /////////////////// -->
			<!-- CHANNELS -->
			<div v-if="isAuth" class="hd__elm-channels">
				<IconChannels />
				<div class="hd__elm-channels-label">{{ channels }}</div>
			</div>

			<!-- /////////////////// -->
			<!-- PROFILE -->
			<div v-if="isAuth" class="hd__elm-profile" @click="onClickProfile">
				<IconProfile />
				<div class="hd__elm-profile-label">Профиль</div>
			</div>

			<div v-if="!isAuth" class="hd__elm-profile">
				<IconProfile />

				<!-- Ссылка на вход -->
				<div
					@click="onClickLogin"
					v-if="currentRoute === LOGIN"
					class="hd__elm-profile-label"
				>
					Войти
				</div>
			</div>
		</div>
	</div>

	<ModalHeaderProfile v-if="modalProfile.isShow" :tariff-type="tariffType" />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconLogo from "@/components/icons/IconLogo.vue";
import IconInputSearch from "@/components/icons/IconInputSearch.vue";
import IconNotify from "@/components/icons/IconNotify.vue";
import IconBalance from "@/components/icons/IconBalance.vue";
import IconChannels from "@/components/icons/IconChannels.vue";
import IconProfile from "@/components/icons/IconProfile.vue";
import ModalHeaderNotify from "@/components/modal/ModalHeaderNotify.vue";
import { mapActions, mapGetters } from "vuex";
import { IModal } from "@/interfaces/IModal";
import ModalHeaderProfile from "@/components/modal/ModalHeaderProfile.vue";
import IconLogoTapi from "@/components/icons/IconLogoTapi.vue";
import { IPaymentChannelDetail } from "@/interfaces/IPaymentChannelDetail";

@Options({
	components: {
		IconLogoTapi,
		ModalHeaderProfile,
		ModalHeaderNotify,
		IconProfile,
		IconChannels,
		IconBalance,
		IconNotify,
		IconInputSearch,
		IconLogo,
	},

	props: {
		balance: { type: String, default: "" },
		channels: { type: Number, default: 0 },
		isNotify: { type: Boolean, default: false },
	},

	computed: {
		...mapGetters("instanceModule", {
			modalNotify: "modalNotify",
			modalProfile: "modalProfile",
		}),
		...mapGetters("authModule", {
			checkAuthGetters: "checkAuthGetters",
		}),
		...mapGetters("paymentModule", {
			payChannelDetail: "payChannelDetailGetters",
		}),
	},

	methods: {
		...mapActions("instanceModule", [
			"modalNotifyAction",
			"modalProfileAction",
			"redirectAction",
		]),
	},
})
export default class HeaderDesktop extends Vue {
	public THEMES: "wapi" | "tapi" = "wapi";
	public vue_app_theme = "";

	public balance: string;

	// Константы. Названия роутов
	public readonly REGISTRATION = "registration";
	public readonly LOGIN = "login";

	// ************************************************************
	// Define mapGetters
	public modalNotify: IModal;
	public modalProfile: IModal;
	public checkAuthGetters: { result: number; isAdmin: boolean };
	public payChannelDetail: IPaymentChannelDetail;

	// ************************************************************
	// Define mapActions
	public modalNotifyAction!: (payload: IModal) => void;
	public modalProfileAction!: (payload: IModal) => void;
	public redirectAction!: (payload: { path: string; page: number }) => void;

	/**
	 * Hook created
	 */
	public created() {
		this.vue_app_theme = process.env.VUE_APP_THEME;
	}

	/**
	 * Tariff type
	 */
	public get tariffType() {
		return this.payChannelDetail.tariff?.type;
	}

	/**
	 * Computed
	 * return boolean
	 * true is authenticated
	 */
	public get isAuth() {
		return this.checkAuthGetters.result !== 0;
	}

	/**
	 * Открыть ссылку с swagger wapi link
	 */
	public openApiUrlHandler() {
		window.open("https://app.wapi.link/swagger/wapi.html", "_target");
	}

	/**
	 * Computed
	 * return boolean
	 * true is admin
	 */
	public get isAdmin() {
		return this.checkAuthGetters.isAdmin;
	}

	public get currentRoute() {
		return this.$route.name;
	}

	/**
	 * Обработка события щелчка по значку колокольчика.
	 * Показываем модалку с уведомлениями
	 */
	public onClickNotify() {
		this.modalNotifyAction({ isShow: true });
	}

	/**
	 * Обработка события щелчка по значку профиля.
	 * Показываем модалку для профиля
	 */
	public onClickProfile() {
		this.modalProfileAction({ isShow: true });
	}

	/**
	 * Вход в систему
	 */
	public onClickLogin() {
		this.redirect("login");
	}

	/**
	 * Переход к регистрации
	 */
	public onClickRegistration() {
		this.redirect("registration");
	}

	/**
	 * Переход на другую страницу
	 * @param routeName
	 * @param id
	 */
	public redirect(routeName: string, id?: number) {
		this.$router.push({ name: routeName, params: { id: id } });
	}

	/**
	 * Переход на домашнюю страницу
	 */
	public async onGoToHomepage() {
		if (this.isAuth) {
			const page = 1;
			this.$router.push({
				path: "/",
				query: {
					page: page,
				},
			});
			this.redirectAction({ path: "/", page: page });
		} else {
			this.redirect("login");
		}
	}
}
</script>

<style scoped lang="scss">
.hd {
	user-select: none;
	&__elm {
		display: grid;
		grid-template-columns: var(--template-columns);
		gap: 2px;
		padding: 0 24px;
		height: 64px;
		align-items: center;
	}

	&__elm-logo {
		display: flex;
		max-width: 120px;
		cursor: pointer;
	}

	&__elm-search {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		direction: ltr;
		border: 1px solid rgb(244, 246, 250);
		border-radius: 12px;
		padding: 8px 12px 8px 12px;
		background-color: rgb(244, 246, 250);
		min-width: 10px;
		opacity: 0.5;
	}

	&__elm-search-input {
		background-color: rgb(244, 246, 250);
		border: 1px solid rgb(244, 246, 250);
		font-size: 16px;
		width: 90%;
	}

	&__elm-search-input:focus {
		outline-color: rgb(244, 246, 250);
		outline-style: solid;
	}

	&__elm-search-icon {
		display: flex;
		width: 25px;
		justify-content: flex-end;
	}

	&__elm-notify {
		display: flex;
		justify-content: flex-end;
		position: relative;
	}

	&__elm-notify-icon {
		cursor: pointer;
	}

	&__elm-notify-modal {
		position: absolute;
		margin-left: -162px;
		margin-top: 10px;
	}

	&__elm-notify-indicate {
		position: absolute;
		background: rgb(235, 255, 82);
		width: 10px;
		height: 10px;
		border-radius: 50%;
		border: 2px solid var(--theme-color);
		top: -2px;
		right: 0;
		cursor: pointer;
	}

	&__elm-balance {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	&__elm-balance-label {
		padding-left: 8px;
		font-size: 16px;
		font-weight: 600;
		color: rgb(255, 255, 255);
	}

	&__elm-channels {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	&__elm-channels-label {
		padding-left: 8px;
		font-size: 16px;
		font-weight: 600;
		color: rgb(255, 255, 255);
	}

	&__elm-profile {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		cursor: pointer;
	}

	&__elm-profile-label {
		cursor: pointer;
		padding-left: 8px;
		font-size: 16px;
		font-weight: 600;
		color: rgb(255, 255, 255);

		&_api {
			margin: 0;
			padding: 4px;
			text-align: center;
			font-weight: normal;
			color: rgb(34, 34, 34);
			background: rgb(212, 248, 211);
			border-radius: 6px;
		}
	}
}
</style>
